import type { ABSmartlyContext, Variant } from '../types/absmartly';

export const STATIC_DEVICE_TYPES = ['mobile', 'desktop'] as const;
const CONTROL = 'control';
const TREATMENT = 'treatment';
const TREATMENT1 = 'treatment1';
const TREATMENT2 = 'treatment2';

export const STATIC_BINARY_EXPERIMENT_VARIANTS = [CONTROL, TREATMENT] as const;
export const STATIC_MULTI_VARIATE_EXPERIMENT_VARIANTS = [CONTROL, TREATMENT1, TREATMENT2] as const;

export enum ABTestVariant {
  Control = CONTROL,
  Treatment = TREATMENT,
  Treatment1 = TREATMENT1,
  Treatment2 = TREATMENT2,
}

export type ABTestVariantResult = `${ABTestVariant}`;
export type ABTestBinaryVariantResult = (typeof STATIC_BINARY_EXPERIMENT_VARIANTS)[number];
export type ABTestMultivariateVariantResult =
  (typeof STATIC_MULTI_VARIATE_EXPERIMENT_VARIANTS)[number];

const getVariants = (experiment: { variants: unknown[] }) => {
  return experiment.variants as Variant[];
};

export const getVariantsArray = (
  context: ABSmartlyContext,
  experimentId: string,
  defaultValue = ABTestVariant.Control as string,
): readonly string[] => {
  const experiment = context.data().experiments?.find(exp => exp.name === experimentId);
  if (!experiment) {
    return [defaultValue];
  }
  const allExperimentVariants = getVariants(experiment);
  return allExperimentVariants.map(variant => variant.name);
};

export const isParamABTestVariantResult = (param: string): param is ABTestVariantResult => {
  return (
    STATIC_BINARY_EXPERIMENT_VARIANTS.includes(param as ABTestBinaryVariantResult) ||
    STATIC_MULTI_VARIATE_EXPERIMENT_VARIANTS.includes(param as ABTestMultivariateVariantResult)
  );
};
